import { useRenderTool } from "@copilotkit/react-core/v2"
import { z } from "zod"

import { ToolProgressCard } from "../components/ToolProgressCard"
import { VerificationCard } from "../components/VerificationCard"

export function useOIOToolRendering() {
  useRenderTool({
    name: "search_gst_precedents",
    parameters: z.object({ query: z.string(), provision: z.string().optional() }),
    render: ({ status, parameters }) => (
      <ToolProgressCard
        icon="🔍"
        title="Searching GST corpus"
        detail={parameters?.query ?? ""}
        status={status}
      />
    ),
  })

  useRenderTool({
    name: "search_legal_graph",
    parameters: z.object({ allegation_type: z.string(), keywords: z.array(z.string()) }),
    render: ({ status, parameters }) => (
      <ToolProgressCard
        icon="🕸"
        title="Searching legal knowledge graph"
        detail={parameters?.allegation_type ?? ""}
        status={status}
      />
    ),
  })

  useRenderTool({
    name: "search_web_grounded",
    parameters: z.object({ query: z.string() }),
    render: ({ status, parameters }) => (
      <ToolProgressCard
        icon="🌐"
        title="Searching grounded web sources"
        detail={parameters?.query ?? ""}
        status={status}
      />
    ),
  })

  useRenderTool({
    name: "verify_statute_refs",
    parameters: z.object({ text: z.string() }),
    render: ({ status, result }) => (
      <VerificationCard
        title="Statute citation check"
        status={status}
        // Only evaluate result when the tool has finished — during inProgress
        // result is undefined and must not be compared to a string sentinel.
        passed={status === "complete" && result === "All statute references valid"}
        errors={
          status === "complete" && result !== "All statute references valid"
            ? String(result)
            : undefined
        }
      />
    ),
  })

  useRenderTool({
    name: "check_mandatory_fields",
    parameters: z.object({
      original: z.string(),
      rewritten: z.string(),
      scenario: z.string().nullable().optional(),
    }),
    render: ({ status, result }) => (
      <VerificationCard
        title="Mandatory fields check"
        status={status}
        passed={status === "complete" && result === "All mandatory fields preserved"}
        errors={
          status === "complete" && result !== "All mandatory fields preserved"
            ? String(result)
            : undefined
        }
      />
    ),
  })
}
